import React from 'react';
import { connect } from 'react-redux';
import FontAwesome from 'react-fontawesome'
import moment from 'moment';
import numeral from 'numeral';
import Pagination from 'react-js-pagination';
import Box from '../Layout/Box';
import ButtonStrip from '../Layout/ButtonStrip';
import BoxButton from '../Layout/BoxButton';
import history from '../../utils/history';
import ModalSelectorFromList from '../Shared/ModalSelectorFromList';
import ModalFilter from './ModalFilter';
import SelectorInput from '../Shared/SelectorInput';
import store from '../../utils/store';
import { changeNumberRegisterToShow, downloadFile, getEvaluacionProveedor, setOrderBy, showHideModalFilter, updateInputs } from '../../actions/reportes';
import { showModalSelector, selectFromSelector } from '../../actions/common';
import { extractKeyValue } from '../../utils/helpers';

export function findValues(c, x) {
    const enums = store.getState().common.get('enums').toJS()
    let value = x.getIn(c.value.split('.'))
    if (c.value === 'estado') {
        value = enums.solicitudes.estados[value]
    } else if (c.value === 'tipo') {
        value = enums.solicitudes.tipos[value].caption
    }
    return value
}

class EvaluacionProveedor extends React.Component {

    handleOpenSelectorProveedor = (list) => {

        let columns = [
            { id: 1, caption: 'Nit', value: 'identificacion', width: '30%' },
            { id: 2, caption: 'Razon Social', value: 'nombre', width: '70%' }
        ];

        const payload = {};

        const fn = (a) => {
            payload.path = list
            payload.value = a;
            this.props.selectFromSelector('MODIFICAR_INPUTS_REPORTES', payload);
        };

        this.props.showModalSelector('Listado de proveedores', columns, `/proveedores`, fn);
    }

    handleChangeProvider(value) {
        return this.props.selectFromSelector('MODIFICAR_INPUTS_REPORTES', {
            path: 'provider',
            value
        });
    }

    newPageOfResults(pg) {
        this.props.search(pg)
    }

    downloadFile(type_report) {
        const url = '/reportes/download_evaluacion_proveedores';
        const params = {
            proveedor_id: this.props.reportes.getIn(['provider_evaluation', 'provider', 'id']),
            proveedor_nombre: this.props.reportes.getIn(['provider_evaluation', 'provider', 'nombre']),
            fecha_inicio: this.props.reportes.getIn(['provider_evaluation', 'initial_date']),
            fecha_fin: this.props.reportes.getIn(['provider_evaluation', 'final_date']),
            filters: this.props.reportes.getIn(['provider_evaluation', 'modalFilter', 'filters']).filter(column => column.get('apply')).toJS(),
            type_report
        };
        return this.props.downloadFile(url, params, type_report);
    }

    render() {
        const { reportes, enums, accumulate, orderBy, showRecords, totalRecords, page } = this.props;

        const tableCols = [
            { id: 1, caption: 'Tipo Solicitud', value: 'Tipo_Solicitud', type: 'number', format: '', width: '8%', enums: extractKeyValue(enums.solicitudes.tipos, 'caption') },
            { id: 2, caption: 'No. Solicitud', value: 'Numero_Solicitud', type: 'number', format: '', width: '6.5%' },
            { id: 3, caption: 'Fecha Solicitud', value: 'Fecha_Solicitud', type: 'datetime', format: 'YYYY-MM-DD', width: '7.3%' },
            { id: 4, caption: 'No. Orden/Contrato', value: 'Orden_Contrato', type: 'string', format: '', width: '7.7%' },
            { id: 5, caption: 'Fecha Orden/Contrato', value: 'Fecha_Documento', type: 'datetime', format: 'YYYY-MM-DD', width: '7.7%' },
            { id: 6, caption: 'Valor Orden/Contrato', value: 'Valor', type: 'number', format: '$ 0,0[.]00', width: '8%' },
            { id: 7, caption: 'Descripción', value: 'Descripcion', type: 'string', format: '', width: '7.7%' },
            { id: 8, caption: 'Fecha Entrega Oficial', value: 'Fecha_oficial', type: 'datetime', format: 'YYYY-MM-DD', width: '8.6%' },
            { id: 9, caption: 'Fecha Entrega Real', value: 'Fecha_real', type: 'datetime', format: 'YYYY-MM-DD', width: '8%' },
            { id: 10, caption: 'CAL', value: 'Calidad', type: 'number', format: '', width: '3%' },
            { id: 11, caption: 'CUM', value: 'Cumplimiento', type: 'number', format: '', width: '3.5%' },
            { id: 12, caption: 'SER', value: 'Gestion_servicio', type: 'number', format: '', width: '3%' },
            { id: 13, caption: 'Observaciones Evaluación', value: 'observaciones', type: 'string', format: '', width: '8%' },
        ];


        const boxActions = [
            <BoxButton key="ba[0][0]" name="search" title="Buscar" onClick={e => this.newPageOfResults(1)} />,
            <BoxButton key="ba[0][1]" name="filter" onClick={ e => this.props.showHideModalFilter(true, tableCols) } title="Filtro"/>,
            <BoxButton key="ba[0][2]" name="file-excel-o" onClick={ e => this.downloadFile('xlsx') } title="Descargar excel"/>,
            <BoxButton key="ba[0][3]" name="file-pdf-o" onClick={ e => this.downloadFile('pdf') } title="Descargar PDF"/>,
        ];


        const pagination = <Pagination
            activePage={page}
            itemsCountPerPage={this.props.showRecords}
            totalItemsCount={totalRecords}
            pageRangeDisplayed={10}
            onChange={(pg) => this.newPageOfResults(pg)}
            firstPageText={<FontAwesome name="angle-double-left" />}
            prevPageText={<FontAwesome name="angle-left" />}
            nextPageText={<FontAwesome name="angle-right" />}
            lastPageText={<FontAwesome name="angle-double-right" />}
        />



        const formRequest = <div className="row" style={{padding:'0px'}}>

            <div className="col-md-4 col-sm-4 col-xs-12">
                <div className="form-group">
                    <label className="control-label">Proveedor</label>
                    <SelectorInput
                        value={reportes.getIn(['provider_evaluation', 'provider']) ? reportes.getIn(['provider_evaluation', 'provider', 'nombre']) : ''}
                        onClick={() => this.handleOpenSelectorProveedor('provider_evaluation.provider')}
                        onReset={() => this.handleChangeProvider(null)}
                    />
                </div>
            </div>
            <div className="col-md-2 col-sm-4 col-xs-12">
                <div className="form-group">
                    <label htmlFor="initial_date" className="control-label">Fecha Inicial</label>
                    <input type="date" className="form-control input-sm" name="initial_date"
                        value={reportes.getIn(['provider_evaluation', 'initial_date'])}
                        onChange={(e) => this.props.updateInputs("provider_evaluation.initial_date", e.target.value)} />
                </div>
            </div>
            <div className="col-md-2 col-sm-4 col-xs-12">
                <div className="form-group">
                    <label htmlFor="final_date" className="control-label">Fecha Final</label>
                    <input type="date" className="form-control input-sm" name="final_date"
                        value={reportes.getIn(['provider_evaluation', 'final_date'])}
                        onChange={(e) => this.props.updateInputs("provider_evaluation.final_date", e.target.value)} />
                </div>
            </div>

            

            {accumulate.size ? <div className="col-md-12">

                <div className="row">

                    <div className="col-md-6">
                        <div className="accumulate-report">
                            <div className="row">
                                <div className="col-md-6">
                                    <label className="control-label">Nota:</label>
                                    <span>{accumulate.get('puntaje_total')}</span>                                                        
                                </div>
                                <div className="col-md-6">
                                    <label className="control-label">Estado:</label>
                                    <span>{reportes.getIn(["provider_evaluation", "state_eval"])}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="accumulate-report">

                            <div className="row">                                                    
                                <div className="col-md-4">
                                    <label className="control-label">Calidad:</label>
                                    <span>{accumulate.get('calidad')}</span>
                                </div>
                                <div className="col-md-4">
                                    <label className="control-label">Cumplimiento:</label>
                                    <span>{accumulate.get('cumplimiento')}</span>
                                </div>
                                <div className="col-md-4">
                                    <label className="control-label">Gestión del servicio:</label>
                                    <span>{accumulate.get('gestion_servicio')}</span>
                                </div>                                                    
                            </div>

                        </div>
                    </div>

                </div>


            </div> : null }

            
        </div>



        return (
            <div className="row" style={{ height: '100%' }}>
                <div className="col-md-12 col-sm-12 col-xs-12" style={{ height: '100%' }}>


                    <Box title="Reporte evaluación de proveedor" stretch>

                        <ButtonStrip actions={boxActions} totalRecords={totalRecords}
                            showRecords={showRecords} pagination={pagination}
                            changeRecordsToShow={(records) => this.props.changeNumberRecordsToShow(records)}
                            formRequest = { formRequest }  
                        />

                        <div className="box-content table-responsive" style={{ flex: 1, height: 0, overflow: 'auto' }}>

                            <table className="table table-condensed table-bordered table-striped table-sorted" id="table-evaluacion-proveedor">
                                <thead>
                                    <tr>
                                        {
                                            tableCols.map(x => {
                                                const style = { width: `${x.width}`, verticalAlign: "middle" }
                                                return (
                                                    <th key={ `th1[${x.id}]` } style={ style } onClick={ e => this.props.setOrderBy(x) } title={x.caption}
                                                        className={ (orderBy.get('field') === x.value) ? (orderBy.get('asc') ? 'asc' : 'desc') : '' }>
                                                        { x.caption }
                                                    </th>
                                                )
                                            })
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        reportes.getIn(['provider_evaluation', 'data']).size > 0 ? reportes.getIn(['provider_evaluation', 'data']).map(x => {
                                            return (
                                                <tr key={`tr1[${x.get('Id')}]`} className={x.get('selected') ? 'info' : ''}>
                                                    {
                                                        tableCols.map(c => {
                                                            let alignment = 'left'
                                                            let value = findValues(c, x)
                                                            if (c.id === 1) {
                                                                value = enums.solicitudes.tipos[value].caption
                                                            }
                                                            else if (c.type) {
                                                                switch (c.type) {
                                                                    case 'datetime':
                                                                        value = value ? moment(value).format(c.format) : '';
                                                                        alignment = 'right';
                                                                        break
                                                                    case 'bool':
                                                                        if (typeof value === 'string') value = parseInt(value, 10)
                                                                        value = <div style={{ textAlign: 'center', fontSize: '1.1em' }}><i className={`fa fa-${value ? 'check-' : ''}square`} /></div>
                                                                        break
                                                                    case 'number':
                                                                        value = value != null ? numeral(value).format(c.format) : ''
                                                                        alignment = 'right'
                                                                        break
                                                                    default:
                                                                }
                                                            }
                                                            const style = { textAlign: alignment }

                                                            if (c.LinkToEdit) {
                                                                return (
                                                                    <td key={`td1[${x.get('id')}][${c.id}]`} className='LinkToEdit' style={style} onClick={e => history.push(window.FOLDER + `/solicitudes/${enums.solicitudes.tipos[x.get('tipo')].url}/${x.get('id')}`)}>{value}</td>
                                                                )
                                                            } else {
                                                                return (
                                                                    <td key={`td1[${x.get('id')}][${c.id}]`} style={style}>{value}</td>
                                                                )
                                                            }
                                                        })
                                                    }
                                                </tr>
                                            )
                                        }) : <tr><td colSpan={tableCols.length}>No existen registros</td></tr>
                                    }
                                </tbody>
                            </table>

                        </div>

                        
                    </Box>
                </div>
                <ModalSelectorFromList />
                <ModalFilter />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { reportes } = state;
    return {
        reportes,
        orderBy: reportes.getIn(['provider_evaluation', 'orderBy']),
        accumulate: reportes.getIn(['provider_evaluation', 'accumulate']),
        enums: state.common.get('enums').toJS(),
        showRecords: reportes.getIn(['provider_evaluation', 'showRecords']),
        totalRecords: reportes.getIn(['provider_evaluation', 'totalRecords']),
        page: reportes.getIn(['provider_evaluation', 'page']),
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        //getProviders: (keyword, cb) => dispatch(getProviders(keyword, cb))
        showModalSelector: (title, fields, url, action) => dispatch(showModalSelector(title, fields, url, action)),
        showHideModalFilter: (state, tableCols) => dispatch(showHideModalFilter(state, tableCols, 'provider_evaluation')),
        setOrderBy: (field) => dispatch(setOrderBy(field, 'provider_evaluation')),
        selectFromSelector: (type, payload) => dispatch(selectFromSelector(type, payload)),
        changeNumberRecordsToShow: (number) => dispatch(changeNumberRegisterToShow(number, 'provider_evaluation')),
        search: (page = 1) => dispatch(getEvaluacionProveedor(page)),
        downloadFile: (url, params, tipo) => dispatch(downloadFile(url, params, `Evaluación Proveedores.${tipo}`)),
        updateInputs: (path, value) => dispatch(updateInputs(path, value)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EvaluacionProveedor);


// WEBPACK FOOTER //
// ./src/components/Reportes/EvaluacionProveedor.jsx